import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { WorkspaceSidebarDto } from '../../../../models/ts/workspace-sidebar-dto.model';
import { BizzMineLocalStorageService } from '../../../shared/services/localStorage/bizzmine-local-storage.service';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { NetworkService } from 'src/app/core/services/network/network.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarApiService {

  private offlinePath = 'api/sidebar/offline';

  public constructor(private http: HttpClient,
              private bizzMineLocalStorage: BizzMineLocalStorageService, private pwaService: PwaService, private networkService: NetworkService) { }

  public getWorkspaceSidebar(workspaceID: number): Observable<WorkspaceSidebarDto> {
    let url = `api/sidebar/${workspaceID}`;
    if(this.pwaService.isPwa() && (!this.pwaService.isOnline || !this.networkService.isOnline)) {
      url = this.offlinePath;
    }
    return this.http.get<WorkspaceSidebarDto>(url)
      .pipe(tap(data => {
        const current = this.bizzMineLocalStorage.getItem('workspaceID');
        if(current == null || (data && +current != data.ID)) {
          this.bizzMineLocalStorage.setItem('workspaceID',data.ID.toString());
        }
      }));
  }

  public getOfflineSidebar(): Observable<WorkspaceSidebarDto> {
    return this.http.get<WorkspaceSidebarDto>(this.offlinePath);
  }
  
  public getWorkspaceSideBarResponse(workspaceID: number): Observable<HttpResponse<WorkspaceSidebarDto>> {
    return this.http.get<WorkspaceSidebarDto>(`api/sidebar/${workspaceID}`, { observe: 'response' });
  }

  public getSettingsSidebar(): Observable<WorkspaceSidebarDto> {
    return this.http.get<WorkspaceSidebarDto>('api/sidebar/settings');
  }
}
